import headIcon from '../components/images/head.png';
import beardIcon from '../components/images/beard.png';
import browsIcon from '../components/images/brows.png';
import nailsIcon from '../components/images/nails.png';
import careIcon from '../components/images/care.png';

export const SERVICE_CATEGORIES = {
    head: {
        id: 'head',
        path: '/head',
        icon: headIcon,
        navLabel: 'Стрижки',
        title: 'Мужская стрижка в Л.Е.В. — классика, кроп, wolf cut, Смоленская',
        description:
            'Мужская, детская, кудрявая и корейская стрижка у барберов с опытом. Косметика DAVINES. Запись онлайн на Смоленском бульваре.',
        keywords:
            'мужская стрижка Москва, барбер Смоленская, стрижка машинкой, wolf cut, кроп, DAVINES, Л.Е.В.',
        intro:
            'Мужские стрижки любой сложности: от классики до креативных образов. Барберы салона Л.Е.В. на Смоленском бульваре, у метро Смоленская.',
    },
    beard: {
        id: 'beard',
        path: '/beard',
        icon: beardIcon,
        navLabel: 'Борода',
        title: 'Моделирование и бритьё бороды — Л.Е.В., Москва',
        description:
            'Классическое и королевское моделирование бороды, бритьё опасной бритвой. Truefitt&Hill, Morgans. Запись онлайн, Смоленский бульвар.',
        keywords:
            'моделирование бороды Москва, бритьё бороды, барбершоп Смоленская, тонирование бороды, Л.Е.В.',
        intro:
            'Стрижка, моделирование и бритьё бороды по классическим техникам барберов. Премиальная косметика и индивидуальный подход.',
    },
    brows: {
        id: 'brows',
        path: '/brows',
        icon: browsIcon,
        navLabel: 'Брови',
        title: 'Мужская коррекция и оформление бровей — Л.Е.В.',
        description:
            'Профессиональная коррекция и окрашивание бровей для мужчин. Аккуратно, естественно, без спешки. Запись онлайн на Смоленской.',
        keywords:
            'мужской бровист Москва, коррекция бровей мужчин, оформление бровей, Смоленская, Л.Е.В.',
        intro:
            'Мужской бровист с опытом — форма и объём бровей, подчёркивающие черты лица. Естественный результат без лишней драмы.',
    },
    nails: {
        id: 'nails',
        path: '/nails',
        icon: nailsIcon,
        navLabel: 'Ногтевой сервис',
        title: 'Мужской маникюр и педикюр — салон Л.Е.В., Москва',
        description:
            'Мужской маникюр и педикюр в салоне мужской эстетики Л.Е.В. на Смоленском бульваре. Аккуратно, гигиенично, запись онлайн.',
        keywords:
            'мужской маникюр Москва, мужской педикюр, ногтевой сервис мужчин, Смоленская, Л.Е.В.',
        intro:
            'Ногтевой сервис для мужчин: маникюр, педикюр и уход за кожей рук и стоп в комфортной атмосфере салона.',
    },
    care: {
        id: 'care',
        path: '/care',
        icon: careIcon,
        navLabel: 'Уход',
        title: 'Уход за лицом и кожей головы для мужчин — Л.Е.В.',
        description:
            'Базовый и премиум уход за лицом, патчи, уход за кожей головы. Профессиональная косметика. Запись онлайн на Смоленской.',
        keywords:
            'мужской уход за лицом Москва, SPA для мужчин, уход за кожей головы, Смоленская, Л.Е.В.',
        intro:
            'SPA-уход для мужчин: чистая кожа, снятие усталости, профилактика перхоти. Профессиональные процедуры и косметика.',
    },
};

export const SERVICE_CATEGORY_PATHS = Object.values(SERVICE_CATEGORIES).map((item) => item.path);

export const getCategoryByPath = (pathname) => {
    const normalized = pathname?.replace(/\/+$/, '') || '/';
    return Object.values(SERVICE_CATEGORIES).find((item) => item.path === normalized) ?? null;
};

export const getCategoryById = (categoryId) => SERVICE_CATEGORIES[categoryId] ?? null;

export const getCategoryPagePath = (categoryId) => getCategoryById(categoryId)?.path ?? null;
